import React, { useState } from "react";
import "./FIcontent.css";
import imageData from "./FI_ImagesData";

const productOptions = [
    "Roller Blinds",
    "Roman Blinds",
    "Colby Blinds",
    "Grayson Blinds",
    "Sierra Blinds",
    "Eton Blinds",
    "Wooden Venetian Blinds",
    "Dorren Blinds",
    "Meliso Blinds",
    "Luzon Blinds",
    "Aric Blinds",
    "Patricia Blinds",
    "Panel Blinds",
    "Vertical Blinds",
    "Curtain with Blinds",
    "Skylight Colby Blinds",
    "Skylight Roman Blinds",
];

const NUM_COLUMNS = 3;

const FIcontent = () => {
    const [filter, setFilter] = useState("");
    const [PriviewImage, setPreviewImage] = useState(null);

    const handleClearFilter = () => {
        setFilter("");
    };

    const filterImages = () => {
        return imageData.filter((img) => {
            if (!img.keywords && filter) return false;
            if (!filter) return !!img.src;

            const keywordArray = img.keywords
                ? img.keywords.split(',').map(k => k.trim().toLowerCase())
                : [];

            const match = keywordArray.some(keyword =>
                keyword.includes(filter.toLowerCase())
            );

            return match && !!img.src;
        });
    };

    const distributeImagesToColumns = (images, columnsCount) => {
        const columns = Array.from({ length: columnsCount }, () => []);
        images.forEach((img, idx) => {
            columns[idx % columnsCount].push(img);
        });
        return columns;
    };

    const filteredImages = filterImages();
    const columns = distributeImagesToColumns(filteredImages, NUM_COLUMNS);

    return (
        <div className="Filter-Inspiration-pg">
            <div className="Filter-Inspiration-container">
                <div className="Page-Main_Dec">
                    <h1 className="Page-title_LowerCase">Inspiration</h1>
                </div>

                <div className="Filter-Inspiration-bar">
                    <select
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        className="Filter-Inspiration-dropdown Filter-Inspiration-d2"
                    >
                        <option value="">Product...</option>
                        {productOptions.map((opt, idx) => (
                            <option key={idx} value={opt}>
                                {opt}
                            </option>
                        ))}
                    </select>

                    <button onClick={handleClearFilter} className="Filter-Inspiration-button">
                        Clear Filter
                    </button>
                </div>

                {filteredImages.length > 0 ? (
                    <div className="Filter-Inspiration-gallery-flex">
                        {columns.map((col, colIdx) => (
                            <div className="filter-inspiration-flex-column" key={colIdx}>
                                {col.map((img, idx) => (
                                    <div className="filter-inspiration-gallery-item" key={idx} onClick={() => setPreviewImage(img.src)}>
                                        <img src={img.src} />
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="filter-inspiration-no-items-message">
                        <p>There are no items in that Selection.</p>
                    </div>
                )}

                {/* Preview modal */}
                {PriviewImage && (
                    <div className="Filter-Inspiration_preview_overlay" onClick={() => setPreviewImage(null)}>
                        <div className="filter-inspiration_image_preview" onClick={(e) => e.stopPropagation()}>
                            <button
                                className="Filter-Inspiration_image_preview_close"
                                onClick={() => setPreviewImage(null)}
                            >
                                ✖
                            </button>
                            <img src={PriviewImage} alt="preview" className="Filter-Inspiration_image" />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FIcontent;
